import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import ButtonLogin from '../Button-Login/Button-Login';
import ButtonPrimary from '../Button-Primary/Button-Primary';
import SignInButton from '../SignInButton/SignInButton';
import { SignOutButton } from '../SignOutButton/SignOutButton';
import styles from './NavBarWithLogin.module.css';

interface NavBarWithLoginProps { }

const NavBarWithLogin: FC<NavBarWithLoginProps> = () => (
  <div className={styles.NavBarWithLogin}>
      <nav className="pds-navigationPrimary pds-navigationPrimary-white">
       <div className="pds-navigationPrimary-container container">
         <div className="pds-navigationPrimary-logo">
           <a data-gtm="navigation-primary" className="pds-navigationPrimary-logo-link pds-link-unstyled" href="/" aria-label="Principal Homepage">
             <img alt="" className="pds-imgLogoGradientRight" />
           </a>
         </div>
         <div className="pds-navigationPrimary-menu-container">
       <ul className="pds-navigationPrimary-tier-one">
         <li>
           <a data-gtm="navigation-primary" href="" aria-haspopup="true">
            
           </a>
         </li>
         <li>
           <a data-gtm="navigation-primary" className="pds-link-unstyled pds-navigationPrimary-dropdown-link" href="" aria-haspopup="true">
           
           </a>
           <ul className="pds-navigationPrimary-tier-two">
             <li>
               <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled"><Link to="/repositories">Acceso a Repositorios</Link></a>
             </li>
             <li>
               <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled"><Link to="/my-repositories">Mis Repositorios</Link></a>
             </li>
             <li>
               <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled"><Link to="/new-repositorys">Nuevo Repositorio</Link></a>
             </li>
           </ul>
         </li>
         <li>
           <a data-gtm="navigation-primary" className="pds-link-unstyled pds-navigationPrimary-dropdown-link" href="" aria-haspopup="true">
           </a>
           <ul className="pds-navigationPrimary-tier-two">
             <li>
               <a data-gtm="navigation-primary"className="pds-link-unstyled"><Link to="/RepositoryContent">Repositorios</Link></a>
             </li>
             <li>
               <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled"><Link to="/RepositoryContent">Repositorios</Link></a>
             </li>
             <li>
               <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled">Logs de auditoria</a>
             </li>
           </ul>
         </li>
       </ul>
     </div>
         <div className="pds-navigationPrimary-actions-container pds-navigationPrimary-tier-one-menu-item">
       
        
 
           <div className="pds-navigationPrimary-search-wrapper">
             <div className="pds-navigationPrimary-search-dropdown pds-navigationPrimary-menu-container">
             </div>
           </div>
         </div>
        
 
    
     <div style={{ display: "flex", justifyContent: "space-between" }}>
           
           <SignInButton />
           
 
           <SignOutButton />
           </div>
   
   
 
       </div>
     </nav> 
  </div>
);

export default NavBarWithLogin;
